/** Testo del carico corrente: ticket aperti di cui la persona è responsabile (DEC-004). */
export function workloadLabel(count: number): string {
  if (count === 0) return 'Nessun ticket aperto';
  return count === 1 ? '1 ticket aperto' : `${count} ticket aperti`;
}
